import { createAction, props } from '@ngrx/store';

export const saveFcmToken = createAction(
  '[Fcm] Save Fcm Token',
  props<{ token: string }>(),
);

export const updateTokenData = createAction(
  '[Messaging] Update Token Data',
  props<{
    actualUserId: string | null;
    oldUserId: string | null;
    actualToken: string | null;
    oldToken: string | null;
  }>(),
);

export const updateTokenDataSuccess = createAction(
  '[Messaging] Update Token Data Success',
);

export const updateTokenDataFailure = createAction(
  '[Messaging] Update Token Data Failure',
  props<{ error: any }>(),
);